<input type="file" class="form-control-file" id="exampleFormControlFile1" (change)="incomingfile($event)" />
<br>
<br>
<a class="btn btn-clear" title="Download JSON" [href]="downloadJsonHref" download="platos.json" *ngIf="downloadJsonHref">
    Descargar Platos
</a>